import {
  NgModule,
  APP_INITIALIZER,
  Optional,
  SkipSelf,
  ErrorHandler,
} from '@angular/core';

import * as services from './services';
import { ErrorHandlerService } from './services';

export function initConfig(
  config: services.CommonAppConfig
): () => Promise<{}> {
  return () => config.load();
}

const IMPORTS = [];

const SERVICES = [
  services.CommonAppConfig,
  services.StateService,
  {
    provide: APP_INITIALIZER,
    useFactory: initConfig,
    deps: [services.CommonAppConfig],
    multi: true,
  },
  {
    provide: ErrorHandler,
    useClass: ErrorHandlerService,
  },
];

const EXPORTS = [];

@NgModule({
  imports: [...IMPORTS],
  declarations: [],
  providers: [...SERVICES],
  exports: [...EXPORTS],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
